import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const DestinationsSection = () => {
  const navigate = useNavigate();

  const handleDevisClick = (destinationName: string, destinationCountry: string) => {
    navigate('/', { replace: true });
    setTimeout(() => {
      const devisSection = document.getElementById('devis');
      if (devisSection) {
        devisSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        
        // Pré-remplir la destination dans le formulaire
        setTimeout(() => {
          const destinationInput = document.getElementById('destination') as HTMLInputElement;
          if (destinationInput) {
            destinationInput.value = `${destinationName}, ${destinationCountry}`;
            destinationInput.dispatchEvent(new Event('input', { bubbles: true }));
            destinationInput.focus();
          }
        }, 500);
      }
    }, 100);
  };

  const destinations = [
    {
      name: 'Cotonou',
      country: 'Bénin',
      image: 'https://public.readdy.ai/ai/img_res/fc5a01963d4fbb5d0950aff7fcc7e2c0.jpg',
      frequency: 'Départs hebdomadaires',
      duration: '5-7 jours',
    },
    {
      name: 'Lomé',
      country: 'Togo',
      image: 'https://readdy.ai/api/search-image?query=Lom%C3%A9%20autonomous%20port%20with%20shipping%20containers%20and%20cargo%20operations%2C%20modern%20West%20African%20port%20city%20with%20palm%20trees%20and%20coastal%20infrastructure%2C%20authentic%20Togo%20maritime%20logistics%20scene%20with%20blue%20ocean%20and%20organized%20freight%20terminal&width=600&height=400&seq=dest-lome-001&orientation=landscape',
      frequency: 'Départs hebdomadaires',
      duration: '5-7 jours',
    },
    {
      name: 'Dakar',
      country: 'Sénégal',
      image: 'https://readdy.ai/api/search-image?query=Dakar%20modern%20port%20with%20large%20cargo%20ships%20and%20container%20terminal%2C%20vibrant%20Senegalese%20coastal%20city%20with%20contemporary%20architecture%20and%20Atlantic%20coastline%2C%20West%20African%20maritime%20hub%20with%20organized%20shipping%20operations%20and%20blue%20ocean%20waters&width=600&height=400&seq=dest-dakar-001&orientation=landscape',
      frequency: 'Départs réguliers',
      duration: '4-6 jours',
    },
    {
      name: 'Abidjan',
      country: 'Côte d\'Ivoire',
      image: 'https://readdy.ai/api/search-image?query=Abidjan%20autonomous%20port%20with%20modern%20skyline%20and%20cargo%20operations%2C%20economic%20capital%20of%20Ivory%20Coast%20with%20contemporary%20buildings%20and%20lagoon%2C%20West%20African%20business%20hub%20with%20shipping%20containers%20and%20maritime%20infrastructure%20under%20blue%20sky&width=600&height=400&seq=dest-abidjan-001&orientation=landscape',
      frequency: 'Départs réguliers',
      duration: '5-7 jours',
    },
    {
      name: 'Accra',
      country: 'Ghana',
      image: 'https://readdy.ai/api/search-image?query=Accra%20Tema%20port%20with%20cargo%20ships%20and%20container%20terminal%2C%20modern%20Ghanaian%20coastal%20city%20with%20vibrant%20markets%20and%20contemporary%20buildings%2C%20West%20African%20logistics%20hub%20with%20organized%20freight%20operations%20and%20blue%20Atlantic%20Ocean&width=600&height=400&seq=dest-accra-001&orientation=landscape',
      frequency: 'Départs hebdomadaires',
      duration: '5-7 jours',
    },
    {
      name: 'Conakry',
      country: 'Guinée',
      image: 'https://readdy.ai/api/search-image?query=Conakry%20port%20with%20cargo%20vessels%20and%20coastal%20infrastructure%2C%20capital%20city%20of%20Guinea%20with%20tropical%20vegetation%20and%20Atlantic%20coastline%2C%20West%20African%20maritime%20scene%20with%20shipping%20operations%20and%20blue%20ocean%20waters&width=600&height=400&seq=dest-conakry-001&orientation=landscape',
      frequency: 'Départs réguliers',
      duration: '6-8 jours',
    },
    {
      name: 'Bamako',
      country: 'Mali',
      image: 'https://readdy.ai/api/search-image?query=Bamako%20city%20with%20Niger%20River%20and%20cargo%20transport%20operations%2C%20vibrant%20Malian%20capital%20with%20traditional%20and%20modern%20architecture%2C%20West%20African%20inland%20logistics%20hub%20with%20river%20commerce%20and%20organized%20freight%20distribution%20under%20clear%20blue%20sky&width=600&height=400&seq=dest-bamako-001&orientation=landscape',
      frequency: 'Départs réguliers',
      duration: '7-10 jours',
    },
    {
      name: 'Ouagadougou',
      country: 'Burkina Faso',
      image: 'https://readdy.ai/api/search-image?query=Ouagadougou%20city%20with%20modern%20buildings%20and%20logistics%20infrastructure%2C%20capital%20of%20Burkina%20Faso%20with%20organized%20freight%20distribution%20center%2C%20West%20African%20inland%20commerce%20hub%20with%20cargo%20trucks%20and%20contemporary%20urban%20landscape%20under%20blue%20sky&width=600&height=400&seq=dest-ouaga-001&orientation=landscape',
      frequency: 'Départs réguliers',
      duration: '7-10 jours',
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12 md:mb-16"
        >
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-primary mb-4 px-4">
            Nos Destinations Prioritaires en Afrique
          </h2>
          <p className="text-gray-600 text-base md:text-lg max-w-2xl mx-auto px-4">
            Nous desservons les principales villes et ports d'Afrique avec des départs réguliers et des délais optimisés pour vos expéditions.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-8 md:mb-12 px-4">
          {destinations.map((destination, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.6 }}
              className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all border border-gray-100 group"
            >
              <div className="relative h-40 md:h-48 w-full overflow-hidden">
                <img
                  src={destination.image}
                  alt={`${destination.name}, ${destination.country}`}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
                <div className="absolute bottom-3 md:bottom-4 left-3 md:left-4 right-3 md:right-4">
                  <h3 className="text-xl md:text-2xl font-bold text-white mb-1">{destination.name}</h3>
                  <p className="text-white/90 text-xs md:text-sm">{destination.country}</p>
                </div>
              </div>

              <div className="p-4 md:p-6">
                <div className="space-y-2 md:space-y-3 mb-4 md:mb-6">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <i className="ri-time-line text-accent text-sm md:text-base"></i>
                      <span className="text-xs text-gray-500">Délai</span>
                    </div>
                    <span className="text-xs md:text-sm font-bold text-primary">{destination.duration}</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <i className="ri-calendar-line text-accent text-sm md:text-base"></i>
                      <span className="text-xs text-gray-500">Fréquence</span>
                    </div>
                    <span className="text-xs md:text-sm font-bold text-accent">{destination.frequency}</span>
                  </div>
                </div>

                <button 
                  onClick={() => handleDevisClick(destination.name, destination.country)}
                  className="w-full bg-primary hover:bg-primary-light text-white py-2.5 md:py-3 rounded-lg text-sm md:text-base font-semibold transition-all whitespace-nowrap cursor-pointer"
                >
                  Demander un Devis
                </button>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4, duration: 0.6 }}
          className="bg-gradient-to-r from-primary to-primary-light rounded-2xl p-6 md:p-12 text-center text-white mx-4"
        >
          <h3 className="text-2xl md:text-3xl font-bold mb-3 md:mb-4">Votre Destination n'est pas Listée ?</h3>
          <p className="text-white/90 text-base md:text-lg mb-4 md:mb-6 max-w-2xl mx-auto">
            Nous étudions toutes les demandes et pouvons organiser des expéditions vers d'autres destinations en Afrique selon vos besoins spécifiques.
          </p>
          <a
            href="#contact"
            className="inline-flex items-center bg-accent hover:bg-accent-dark text-white px-6 md:px-8 py-3 md:py-4 rounded-full text-sm md:text-base font-semibold transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            Contactez-Nous
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default DestinationsSection;
